import '../../../scss/partials/_accordion.scss';

class AccordionPresenter {
  constructor() {
    this.descriptionEl = document.querySelector('[data-product-description]');
  }

  toggleAccordion = () => {
    const acc = document.getElementsByClassName('accordion');
    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function() {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    }

    const firstEl = document.querySelector(
      '[data-product-description] .accordion'
    );
    if (!firstEl) return;
    firstEl.click();
  };

  // eslint-disable-next-line class-methods-use-this
  init(data) {
    if (!data || data.length <= 1) return;
    this.descriptionEl.innerHTML = '';
    data.forEach((item, index) => {
      let className;
      if (index % 2 === 0) {
        className = 'accordion';
      } else {
        className = 'content';
      }
      this.descriptionEl.innerHTML += `<div class="${className}">${item}</div>`;
    });

    this.toggleAccordion();
  }
}

export default new AccordionPresenter();
